import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import React from "react";
import { FlyerDetailPageFormPositionCategoryProps } from "./flyer-detail-page-form-position-category-pill.props";
import {
  HostContainer,
  TextContainer,
  CategoryPillRemoveIcon,
} from "./flyer-detail-page-form-position-category-pill.styles";

export const FlyerDetailPageFormPositionCategoryPill = (
  props: FlyerDetailPageFormPositionCategoryProps
) => (
  <HostContainer>
    <TextContainer>{props.children}</TextContainer>
    <CategoryPillRemoveIcon showIf={props.canEdit} onClick={props.onRemove}>
      <HighlightOffIcon />
    </CategoryPillRemoveIcon>
  </HostContainer>
);
